import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Stack,
  Button,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useState } from 'react';

export function ModalTraspasCaja({
  open,
  onClose,
  state,
  fechaSeleccionada = null,
  díaBloqueado = false,
  subirFuturo = null
}) {
  const [monto, setMonto] = useState('');
  const [direccion, setDireccion] = useState('CAJ_A_QR');
  const [razon, setRazon] = useState('');

  const handleRegistrar = async () => {
    if (!monto || isNaN(monto) || parseFloat(monto) <= 0) {
      alert('Monto inválido');
      return;
    }

    if (díaBloqueado) {
      alert('⛔ No puedes registrar traspasos cuando hay un arqueo completado en el día');
      return;
    }

    const success = await state.traspasoQRCaja(parseFloat(monto), direccion, fechaSeleccionada);

    if (success) {
      alert('Traspaso registrado');
      setMonto('');
      setRazon('');
      setDireccion('CAJ_A_QR');
      onClose();
    }
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Traspaso Caja ↔ QR</DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
              Dirección del Traspaso
            </Typography>
            <ToggleButtonGroup
              value={direccion}
              exclusive
              onChange={(e, val) => val && setDireccion(val)}
              fullWidth
            >
              <ToggleButton value="CAJ_A_QR">Caja → QR</ToggleButton>
              <ToggleButton value="QR_A_CAJ">QR → Caja</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <TextField
            label="Monto"
            type="number"
            fullWidth
            value={monto}
            onChange={(e) => setMonto(e.target.value)}
            inputProps={{ step: '0.01' }}
          />

          <TextField
            label="Razón (opcional)"
            fullWidth
            multiline
            rows={2}
            value={razon}
            onChange={(e) => setRazon(e.target.value)}
            placeholder="Ej: Transferencia de saldo"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          disabled={díaBloqueado || !monto}
          onClick={handleRegistrar}
        >
          Registrar Traspaso
        </Button>
      </DialogActions>
    </Dialog>
  );
}
